<template>
  <input
    v-model="inputValue"
    class="case-device-input"
    :name="name"
    type="text"
    style="display: none"
  />
</template>

<script>
import pipe from 'ramda/src/pipe'
import BaseInput from '../BaseInput'
export default {
  name: 'CaseDeviceInput',
  extends: BaseInput,
  props: {
    deviceId: {
      type: Number,
      default: null,
    },
    caseTypeId: {
      type: Number,
      default: null,
    },
    caseTypes: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: 'case_device_id',
    },
  },
  watch: {
    deviceId(newValue) {
      this.updateValue()
    },
    caseTypeId(newValue) {
      this.updateValue()
    },
  },
  created() {
    this.updateValue()
  },
  methods: {
    updateValue() {
      this.inputValue = pipe(this.getCaseType, this.getCaseDeviceId)()
    },
    getCaseType() {
      return this.caseTypes.find(
        (ct) => Number(ct.id) === Number(this.caseTypeId)
      )
    },
    getCaseDeviceId(caseType) {
      return (
        caseType?.devices?.find(
          (d) => Number(d.device_id) === Number(this.deviceId)
          // eslint-disable-next-line camelcase
        )?.case_device_id ?? null
      )
    },
  },
}
</script>
